import { usePropertyExpectedListingPrice } from '../../../queries/PropertyFields/NonRentalCoreFields';
import { MoneyBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';
import { formatCurrencyOrUndefined } from '@apply/ui';

interface ExpectedListingPriceProps {
    propertyGuid: string;
    required?: boolean;
    structureType: string | undefined;
    isReview?: boolean;
}

export const ExpectedListingPrice: React.FC<ExpectedListingPriceProps> = ({
    propertyGuid,
    required = false,
    structureType,
    isReview = false,
}) => {
    const [expectedListingPrice, set_expectedListingPrice] = usePropertyExpectedListingPrice(propertyGuid);

    const listingPriceLabel = () => {
        if (
            structureType === 'Duplex' ||
            structureType === 'Triplex' ||
            structureType === 'Quadplex' ||
            structureType === '5+ Unit'
        ) {
            return 'Total Expected Sale Price';
        } else {
            return 'Expected Listing Price';
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={listingPriceLabel()}
                    value={formatCurrencyOrUndefined(Number(expectedListingPrice))}
                />
            ) : (
                <MoneyBox
                    id='expectedListingPrice'
                    allowNegative={false}
                    value={expectedListingPrice}
                    onChange={(value) => {
                        set_expectedListingPrice(value);
                    }}
                    required={required}
                    label={listingPriceLabel()}
                    displayChange={false}
                />
            )}
        </>
    );
};
